import type {
  ArtistLanguageDto,
  ArtistLanguageLevels
} from '@customTypes/types';
import { useForm } from '@mantine/form';
import { useDisclosure } from '@mantine/hooks';
import { useParams } from '@tanstack/react-router';
import { useMemo, useState } from 'react';

import { useArtistProfileLanguagesMutation } from '@/shared/api/requests';
import { LANGUAGES_LIST } from '@/shared/data/languages';

export const useForeignLanguage = () => {
  const [search, setSearch] = useState('');
  const [currentLang, setCurrentLang] = useState('');
  const [currentLevel, setCurrentLevel] = useState<ArtistLanguageLevels | null>(
    null
  );
  const [opened, { open, close }] = useDisclosure(false);
  const { id: profileId } = useParams({ from: '/artist/$id' });
  const form = useForm<{ languages: ArtistLanguageDto[] }>({
    initialValues: {
      languages: []
    }
  });

  const languageMutation = useArtistProfileLanguagesMutation({
    options: {
      onSuccess: () => {
        close();
      }
    }
  });

  const filteredLanguages = useMemo(
    () =>
      LANGUAGES_LIST.filter(
        (language) =>
          !form
            .getValues()
            .languages.some((item) => item.name === language.label)
      ).filter((language) =>
        language.label.toLowerCase().includes(search.toLowerCase())
      ),
    [search, form.getValues().languages]
  );

  const onSubmit = form.onSubmit(async (values) => {
    await languageMutation.mutateAsync({
      params: {
        profileId,
        data: values.languages
      }
    });
  });

  return {
    state: {
      modal: {
        opened,
        open,
        close
      },
      form,
      filteredLanguages,
      search,
      currentLang,
      currentLevel
    },
    functions: {
      setSearch,
      onSubmit,
      setCurrentLang,
      setCurrentLevel
    }
  };
};
